import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** Google SSO callback — exchanges the Emergent session_id for an app JWT.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
import React, { useEffect, useRef, useState } from 'react';
import { resolveBackendBase } from '../utils/backendBase.js';
import { storeTokens } from '../utils/authToken.js';
import { establishSession } from '../utils/sessionSetup.js';
export default function AuthCallback() {
    const hasProcessed = useRef(false);
    const [error, setError] = useState('');
    useEffect(() => {
        if (hasProcessed.current)
            return;
        hasProcessed.current = true;
        (async () => {
            const hash = window.location.hash || '';
            const m = hash.match(/session_id=([^&]+)/);
            const sessionId = m ? decodeURIComponent(m[1]) : '';
            try {
                window.history.replaceState(null, '', window.location.pathname + window.location.search);
            }
            catch (e) { /* ignore */ }
            if (!sessionId) {
                window.location.replace('/login');
                return;
            }
            try {
                const resp = await fetch(`${resolveBackendBase()}/api/auth/google/session`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    credentials: 'include',
                    body: JSON.stringify({ session_id: sessionId }),
                });
                const data = await resp.json().catch(() => ({}));
                if (!resp.ok) {
                    setError(data?.detail || 'فشل تسجيل الدخول عبر Google');
                    return;
                }
                storeTokens(data);
                await establishSession({ username: data.username, userId: data.user_id,
                    role: data.role, permissions: data.permissions, token: data.access_token });
                window.location.replace('/');
            }
            catch (e) {
                setError('تعذر الاتصال بالخادم');
            }
        })();
    }, []);
    return (_jsx("div", { className: "min-h-screen flex flex-col items-center justify-center p-4", "data-testid": "google-auth-callback", children: error ? (_jsxs("div", { className: "apple-card p-10 max-w-[420px] w-full text-center space-y-4", children: [_jsx("div", { className: "text-4xl", children: "\u26A0\uFE0F" }), _jsx("h1", { className: "text-xl font-bold text-[#1D1D1F]", "data-testid": "google-auth-error", children: error }), _jsx("p", { className: "text-sm text-[#86868B]", children: "\u062A\u0623\u0643\u062F \u0645\u0646 \u0631\u0628\u0637 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0628\u062D\u0633\u0627\u0628\u0643 \u0641\u064A \u0627\u0644\u0646\u0638\u0627\u0645 (\u0635\u0641\u062D\u0629 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646) \u062B\u0645 \u062D\u0627\u0648\u0644 \u0645\u062C\u062F\u062F\u0627\u064B." }), _jsx("a", { href: "/login", className: "apple-button inline-block", "data-testid": "google-auth-back-to-login", children: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644" })] })) : (_jsxs("div", { className: "flex flex-col items-center gap-4", children: [_jsx("span", { className: "w-10 h-10 border-4 border-blue-200 border-t-[#0071E3] rounded-full animate-spin" }), _jsx("p", { className: "text-[#86868B]", children: "\u062C\u0627\u0631\u064D \u0625\u062A\u0645\u0627\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0639\u0628\u0631 Google\u2026" })] })) }));
}
